import React, { Component } from 'react'
import { Container, Row, Col, Glyphicon } from 'react-bootstrap'

/* TODO: Correct top right information when page shrinks */

class Header extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <Container fluid={true} className='header-background header-font'>
                {/* <img src={require('./img/background_1.jpg')} className='header-background'/> */}
                <Row>
                    <Col lg={2} xs={4}><img className='logo' src={require('./img/dapperDoggy.png')} alt='' /></Col>
                    <Col lg={6} xs={8} className='header-name'>
                        <Row>
                            <Col className='name-text'>
                                Dapper Doggy
                            </Col>
                        </Row>
                        <Row>
                            <Col className='name-sub' xs={{offset:1}}>
                                DAY SPAW & BOUTIQUE
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={4} className='header-text d-none d-lg-block'>
                        <Row className=''>
                            <Col lg={{offset:4, span:2}}>
                                <i className='fas fa-phone fa-2x fa-fw dapper-blue header-ico'></i>
                            </Col>
                            <Col className='header-text-solo'>
                                (208) 731-0213
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={{offset:4, span:2}}>
                                <i className='fas fa-map-marker-alt fa-2x fa-fw dapper-blue header-ico'></i>
                            </Col>
                            <Col>
                                <Row>
                                    <Col className='header-text-topline'>
                                        314 2nd Ave E
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        Twin Falls, ID 83301
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={{offset:4, span:2}}>
                                <i className='far fa-clock fa-2x fa-fw dapper-blue header-ico'></i>
                            </Col>
                            <Col>
                                <Row>
                                    <Col className='header-text-topline'>
                                        8:00 am to 5:00 pm
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        Monday - Friday
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        )
    }
}



export default Header